<template>
    <!-- FAQ Section -->
    <section id="faq" class="faq py-12 bg-[url('/coisar-wave-grey.svg')] bg-center bg-cover bg-no-repeat">
        <div class="flex flex-col container mx-auto px-4 z-40 gap-8">
            <h2 class="landing-h2 text-center">
                <template v-for="currentBlok in blok.headline">
                    <span :class="[currentBlok.hasColorGradient ? 'gradient-dark' : '']">{{ currentBlok.text }}&nbsp;</span> 
                </template>
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <!-- Left -->
                <div class="space-y-4 z-40">
                    <Disclosure v-for="faq in firstFaqs" :key="faq.question">
                    <template #default="{ open }">
                        <div>
                        <DisclosureButton
                            :class="[
                            'w-full flex items-center px-6 py-4 border border-gray-300 rounded-full focus:outline-none',
                            open ? 'bg-gradient-to-b from-indigo-900 to-indigo-700 border-transparent text-white' : 'bg-white text-gray-900'
                            ]"
                        >
                            <div :class="[ 'flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-4', open ? 'bg-white text-indigo-900' : 'bg-gray-900 text-white' ]">
                            <font-awesome-icon :icon="['fasr', 'chevron-down']" class="w-4 h-4" />
                            </div>
                            <span class="flex-grow text-left">{{ faq.question }}</span>
                        </DisclosureButton>
                        <DisclosurePanel v-if="open" class="mt-2">
                            <div class="w-full bg-indigo-700 text-white px-6 py-4 rounded-3xl">
                            <p>{{ faq.answer }}</p>
                            </div>
                        </DisclosurePanel>
                        </div>
                    </template>
                    </Disclosure>
                </div>
            <!-- Right -->
                <div class="space-y-4 z-40">
                    <Disclosure v-for="faq in secondFaqs" :key="faq.question">
                    <template #default="{ open }">
                        <div>
                        <DisclosureButton
                            :class="[
                            'w-full flex items-center px-6 py-4 border border-gray-300 rounded-full focus:outline-none',
                            open ? 'bg-gradient-to-b from-indigo-900 to-indigo-700 border-transparent text-white' : 'bg-white text-gray-900'
                            ]"
                        >
                            <div
                            :class="[
                                'flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-4',
                                open ? 'bg-white text-indigo-900' : 'bg-gray-900 text-white'
                            ]"
                            >
                            <font-awesome-icon :icon="['fasr', 'chevron-down']" class="w-4 h-4" />
                            </div>
                            <span class="flex-grow text-left">{{ faq.question }}</span>
                        </DisclosureButton>
                        <DisclosurePanel v-if="open" class="mt-2">
                            <div class="w-full bg-indigo-700 text-white px-6 py-4 rounded-3xl">
                            <p>{{ faq.answer }}</p>
                            </div>
                        </DisclosurePanel>
                        </div>
                    </template>
                    </Disclosure>
                </div>
            </div>
            <div class="mt-4 flex justify-center">
                <router-link to="/landing#hero-form-coisar" class="btn-primary">{{ blok.button }}</router-link>
            </div>
        </div>
    </section>
</template>

<script setup>

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { computed } from 'vue'

defineProps({ blok: Object })

const faqs = [
    {
        question: 'Was ist Coisar?',
        answer: 'Coisar ist eine die erste und einzige Software, die alle Infromationen zu deinem Human Design detailliert und verständlich zusammengefasst darstellt. Du erhältst Zugang zu umfassenden Details über jedes Element deines Charts, einschließlich Definitionen, Toren, Linien und viel mehr. Alles in einer modernen und leicht verständlichen Sprache geschrieben und hundertefach erprobt. Du wirst erstaunt sein, wie viel du mit Coisar über dich selbst, deine Potenziale, Stärken und Schwächen erfahren wirst. Angereichert mit hilfreichen Handlungsanweisungen und Affirmationen sowie Auswirkungen auf dein privates und berufliches Umfeld wird Coisar zu deinem Begleiter auf deinem Weg zu dir selbst und deiner Selbstverwirklichung.'
    }, {
        question: 'Was beinhaltet eine Coisar Auswertung?',
        answer: 'Die Coisar Auswertung eröffnet dir eine tiefgehende und sehr ausführliche Analyse aller Aspekte deines Human Design Charts. Die Informationenen beinhalten ein breites Spektrum an Wissen, Selbsterkenntnis und so viel mehr - angefangen bei den Human Design Typen, Profilen, Autoritäten, Energiezentren, Splits, Toren, Kanälen uvm.'
    }, {
        question: 'Ist eine Coisar Auswertung auch für Human Design Neulinge ohne Vorkenntnisse geeignet?',
        answer: 'Ja, absolut! Coisar ist dafür konzipiert, dir einen verständlichen Einstieg sowie die Informationen aus den Tiefen deine das Human Design schön designed, sehr verständlich, ausführlich und erkenntnisreich zu bieten. Coisar ist ideal, um dir grundlegende und tiefergehende Einsichten in dein individuelles Design inkl. Handlungsanweisungen, Affirmationen uvm zu geben und das ganz unabhängig von deiner Vorerfahrung.'
    }, {
        question: 'Welche Coisar Auswertung ist für mich die richtige?',
        answer: 'Basic Auswertung: Ideal für Einsteiger. Du erhältst eine grundlegende Analyse deines Human Design Typs und Profils. Premium Auswertung: Umfasst alles in der Basic Auswertung zzgl. detaillierte Analysen deiner Definitionsbereiche, aktivierten Kanäle, Planetenbedeutungen und detaillierte Beschreibungen deiner aktivierten Tore inklusive Herausforderungen und Linien uvm.'
    }, {
        question: 'Ist die Auswertung wirklich individuell auf mich zugeschnitten?',
        answer: 'Ja, jede Auswertung ist einzigartig und massgeschneidert. Mit Coisar werden aus einer umfangreichen Datenbank für dich persönllich die auf dich zugeschnittenen und massgeschneiderten Texte zusammengefügt und dargestellt. Das macht jedes Coisar genauso einzigartig wie jeden Menschen.'
    }, {
        question: 'Ist ein kostenloser Chart nicht auch erstmal ausreichend?',
        answer: 'Für deinen ersten Einblick ist die kostenlose Coisar Basic Auswertung ausreichend. Es beinhaltet grundlegende Informationen zu deinem Typ und dein Profil im Human Design. Wenn du danach mehr erfahren möchtest, kannst du gerne die Premium Version erwerben.”'
    }, {
        question: 'In meiner Auswertung gibt es Texte, die sich wiederholen. Ist das dann richtig?',
        answer: 'Ja, das ist normal. Texte, insbesondere bei Toren, die sich wiederholen, können sich die Texte wiederholen. Jeder Planet bringt jedoch unterschiedliche Themen mich sich, die das Tor mit dieser Thematik einfärben.'
    }, {
        question: 'Was unterscheidet Coisar von einem 1:1 Reading mit einem Human Design Coach?',
        answer: 'Coisar stellt dir eine eine grafisch aufbereitete und faktische Zusammenfassung deines Chart zusammen. Ein persönliches Reading geht tiefer und personalisiert die Informationen basierend auf deinem Leben und deinen Herausforderungen.'
    }, {
        question: 'Was kann ich tun, wenn ich meine genaue Geburtsuhrrzeit nicht kenne?',
        answer: 'Für grundlegende Informationen ist die exakte Uhrzeit oft nicht entscheidend. Nutze die Coisar Basis Auswertung mit verschiedenen Uhrzeiten und beobachte eventuelle Veränderungen. Für detailliertere Analysen wie z.B. die Variablen kannst du deine Geburtszeit beim Standesamt erfragen oder kinesiologisch bestimmen lassen.'
    }, {
        question: 'Was sind die Variablen im Human Design?',
        answer: 'Variablen liefern präzise Informationen über Umgebung, Verdauung, Motivation etc. Hier ist eine genaue Geburtszeit essentiell, da sich Details minutengenau ändern können.'
    }, {
        question: 'Sind meine Daten sicher?',
        answer: 'Ja, im Gegensatz zu vielen anderen Anbietern speichern wir deine Daten sicher in der EU.'
    }
]

const halfIndex = Math.ceil(faqs.length / 2);
const firstFaqs = computed(() => faqs.slice(0, halfIndex));
const secondFaqs = computed(() => faqs.slice(halfIndex));

</script>